const names = {
  "XS4 Original+": "XS4 Original +",
  "XS4 Mini Ansi": "XS4 Mini ANSI",
  "XS4 One Plus": "XS4 One S",
  Dbolt: "DBolt Touch",
  Neo: "Neo Cylinder",
  EcoLock: "XS4 ECO.Lock",
  "Bluenet Nodes": "BLUEnet Node",
  "Bluenet Repeaters": "BLUEnet Repeater",
  "RFNet Nodes": "RFNet Node",
  Encoders: "Encoder",
  NCoder: "Ncoder",
  "Bluenet Controllers": "Bluenet Door Controller",
  UBox: "UBOX",
  "Inroom nodes": "InRoom Node",
  "PPD CONTACTLESS": "PPD Contactless",
};

const urlNames = {
  space: "PRO ACCESS SPACE",
  nebula: "NEBULA",
  locks: "Access Point",
};
export function checkName(name) {
  if (names.hasOwnProperty(name)) {
    return names[name];
  }
  return name;
}

export function checkUrlName(url) {
  if (urlNames.hasOwnProperty(url)) {
    return urlNames[url];
  }
  return url;
}
